<template>
	<div
		:data-active="active"
		@dragenter.prevent="setActive"
		@dragover.prevent="setActive"
		@dragleave.prevent="setInactive"
		@drop.prevent="onDrop"
	>
		<slot :dropZoneActive="active"></slot>
	</div>
</template>

<script>
	import { onMounted, onUnmounted, ref } from "vue";

	export default {
		emits: ["files-dropped"],

		setup: ({ emit }) => {
			function onDrop(e) {
				setInactive();
				emit("files-dropped", [...e.dataTransfer.files]);
			}

			// Create `active` state and manage it with functions

			let active = ref(false);
			let inActiveTimeout = null; // add a variable to hold the timeout key

			function setActive() {
				active.value = true;
				clearTimeout(inActiveTimeout); // clear the timeout
			}
			function setInactive() {
				// wrap it in a `setTimeout`
				inActiveTimeout = setTimeout(() => {
					active.value = false;
				}, 50);
			}

			function preventDefaults(e) {
				e.preventDefault();
			}

			const events = ["dragenter", "dragover", "dragleave", "drop"];

			onMounted(() => {
				events.forEach((eventName) => {
					document.body.addEventListener(eventName, preventDefaults);
				});
			});

			onUnmounted(() => {
				events.forEach((eventName) => {
					document.body.removeEventListener(eventName, preventDefaults);
				});
			});

			return {
				active,
				onDrop,
				setActive,
				setInactive,
			};
		},
	};
</script>
